export const VENDOR_PIPELINE = ["New Enquiry", "Contact Attempted", "Contacted / Qualified", "Follow-up Required", "Vendor Interested",
  "Referred to Auction Partner", "Auction Instruction Signed", "Photography / Marketing", "Listed for Auction",
  "Sold / Awaiting Completion", "Sale Completed", "Commission Received"];
export const VENDOR_OUTCOMES = ["Not Interested", "Lost", "Withdrawn", "Bought by Emerald Crown"];
export const VENDOR_STAGES_ALL = [...VENDOR_PIPELINE, ...VENDOR_OUTCOMES];
export const REFERRAL_STAGES = VENDOR_PIPELINE.slice(5);
export const MILESTONES = [
  ["Referred to Auction Partner", "referral_date", "Referral made"],
  ["Auction Instruction Signed", "instruction_date", "Instruction signed"],
  ["Photography / Marketing", "marketing_date", "Photography / marketing"],
  ["Listed for Auction", "listing_date", "Listed"],
  ["Sold / Awaiting Completion", "sale_date", "Sold (awaiting completion)"],
  ["Sale Completed", "completion_date", "Sale completed"],
  ["Commission Received", "commission_received_date", "Commission received"],
];
export const INVESTOR_PIPELINE = ["New Lead", "Contacted", "Qualified", "Deal Sent", "Reserved", "Completed", "Nurture", "Lost"];

export const stageTone = (s) => {
  if (["Completed", "Agreed", "Sale Completed", "Commission Received", "Bought by Emerald Crown"].includes(s)) return "bg-emerald-500/15 text-emerald-300 border-emerald-500/30";
  if (["Lost", "Not Interested", "Withdrawn"].includes(s)) return "bg-red-500/15 text-red-300 border-red-500/30";
  if (s === "Nurture" || s === "Follow-up Required") return "bg-slate-500/15 text-slate-300 border-slate-500/30";
  if (s && s.startsWith("Referred")) return "bg-violet-500/15 text-violet-300 border-violet-500/30";
  if (s === "New Lead" || s === "New Enquiry") return "bg-blue-500/15 text-blue-300 border-blue-500/30";
  return "bg-brass/15 text-brass border-brass/30";
};

export const typeBadge = (t) =>
  t === "Both" ? "bg-brass/20 text-brass"
  : t === "Investor" ? "bg-blue-100 text-blue-800"
  : t === "Vendor" ? "bg-amber-100 text-amber-800"
  : "bg-white/10 text-emerald-100/70";

export const ukDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB") : "—");
export const ukDateTime = (d) => (d ? new Date(d).toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" }) : "—");

export const TRANSACTION_TYPES = ["Vendor Purchase", "Investor Sourcing Fee", "Agency / Referral Fee", "Other"];
export const gbp = (v) => (v || v === 0) && !isNaN(v) ? "£" + Number(v).toLocaleString("en-GB", { maximumFractionDigits: 0 }) : "£0";
